import { BuildingsComparisonStoreState } from './buildings-comparison';

export interface State {
    buildingsComparison: BuildingsComparisonStoreState.State;
}

export const initialState: State = {
    buildingsComparison: BuildingsComparisonStoreState.initialState
};
